import type { buttonCent, spotOperations, spotForwardOperations, otherCurrenciesOperations, manualOperations, TradingTotalsResponse } from './type'
import fxTradingCentData from "../../../data/fxTradingCentList.json"
import spotData from "../../../data/fxTradingSpotData.json"
import spotForwardData from "../../../data/fxTradingSpotForwardData.json"
import manualData from "../../../data/fxTradingManualData.json"
import otherCurrenciesData from "../../../data/fxTradingOtherCurrenciesData.json"

export class fxTradingService {
  async getButtonCentList(): Promise<buttonCent[]> {
    const data = fxTradingCentData.data
    return data;
  }

  async getSpotOperations(): Promise<spotOperations[]> {
    const data = spotData.data
    return data;
  }

  // Spot Forward Operations
  async getSpotForwardOperations(): Promise<spotForwardOperations[]> {
    const data = spotForwardData.data
    return data;
  }

  // Other Currencies Operations
  async getOtherCurrenciesOperations(): Promise<otherCurrenciesOperations[]> {
    const data = otherCurrenciesData.data
    return data;
  }

  // Manual Operations
  async getManualOperations(): Promise<manualOperations[]> {
    const data = manualData.data
    return data;
  }

  // Legacy method for backward compatibility
  async getTradingData(): Promise<spotOperations[]> {
    return this.getSpotOperations()
  }
}